import { Mesh } from "three";
import { MergeMeshCommand } from "./commands/MergeObjectCommand";
import { RemoveObjectCommand } from "./commands/RemoveObjectCommand";
import { Editor } from "./editor";
import { SimplifyModifier } from 'three/examples/jsm/modifiers/SimplifyModifier'
import { SetGeometryCommand } from "./commands/SetGeometryCommand";


const IS_MAC = /macintosh|mac os x/i.test(navigator.userAgent);

/**
 * @return void 或 true 阻止默认事件
 */
type KeyHandlerFn=(event:KeyboardEvent)=>boolean|void;

export class Keyboard{
  editor:Editor;
  dom:Document|HTMLElement;
  pause:boolean=false;
  classNameEffect:string[]=['panda-viewport','panda-outliner'];

  keyMap:Map<string,KeyHandlerFn> = new Map([
    ['Mod-c',(event:KeyboardEvent)=>{
      this.editor.copy();
    }],
    ['Mod-v', (event:KeyboardEvent)=>{
      this.editor.paste();
    }],
    ['Mod-z', (event:KeyboardEvent)=>{
      this.editor.undo();
    }],
    ['Mod-y', (event:KeyboardEvent)=>{
      this.editor.redo();
    }],
    ['T',(event:KeyboardEvent)=>{
      this.editor.signals.transformModeChanged.dispatch('translate');
      return true;
    }],
    ['R',(event:KeyboardEvent)=>{
      this.editor.signals.transformModeChanged.dispatch('rotate');
      return true;
    }],
    ['S',(event:KeyboardEvent)=>{
      this.editor.signals.transformModeChanged.dispatch('scale');
      return true;
    }],
    ['M',(event:KeyboardEvent)=>{
      if(this.editor.selected){
        const children=this.editor.selected.children;
        if(children.length>=2){
          this.editor.execute(new MergeMeshCommand(this.editor,children[0] as Mesh,children[1] as Mesh));
        }
      }
      return true;
    }],
    ['Delete', (event:KeyboardEvent)=>{
      if(this.editor.selected){
        this.editor.execute( new RemoveObjectCommand( this.editor, this.editor.selected ) );
      }
      return true;
    }],
    ['Backspace', (event:KeyboardEvent)=>{
      if(this.editor.selected){
        this.editor.execute( new RemoveObjectCommand( this.editor, this.editor.selected ) );
      }
      return true;
    }],
  ]);

  constructor( editor:Editor,dom:HTMLElement|Document=document ) {
    this.editor=editor;
    this.dom=dom;
    this.listen();
  }

  public key(key:string,handler:KeyHandlerFn){
    if(this.keyMap.has(key)){
      throw new Error(`快捷键[${key}]冲突`);
    }
    this.keyMap.set(key,handler);
  }

  public isEffect(event:KeyboardEvent){
    if(event.target){
      const target=event.target as HTMLElement;
      for(let i=0;i<this.classNameEffect.length;i++){
        if(target.classList.contains(this.classNameEffect[i])){
          return true;
        }
      }

    }
    return false;
  }

  private onKeydown(event:KeyboardEvent) {
    // console.log(event);
    // 获取按下的键名
    if(this.pause)return;
    if(!this.isEffect(event))return;
    const key = this.getKey(event);
    // 检查是否按下了组合按键
    if (event.shiftKey || event.ctrlKey) {
      // 组合按键格式：ModifierKey-Key
      const combinationKey = `${this.getModifierKey(event)}-${key}`;
      // 查找并执行组合按键对应的操作
      if (this.keyMap.has(combinationKey)) {
        const operation = this.keyMap.get(combinationKey);
        if(operation){
          const prevent=operation(event);
          if(prevent===undefined||prevent===true)
          event.preventDefault();
        }

      }
    } else {
      // 查找并执行按键对应的操作
      if (this.keyMap.has(key)) {
        const operation = this.keyMap.get(key);
        if(operation){
          const prevent=operation(event);
          if(prevent===undefined||prevent===true)
          event.preventDefault();
        }

      }
    }
  }

  listen(){
    // 监听键盘按下事件
    // this.dom.addEventListener('keydown', this.onKeydown.bind(this));
    this.dom.addEventListener('keydown', this.onKeydown.bind(this));
  }

  // 辅助函数，获取按下的键名
  getKey(event:KeyboardEvent) {
    // 使用event.key获取按下的键名
    return event.key;//.toUpperCase();
  }

  // 辅助函数，获取组合按键中的修饰键
  getModifierKey(event:KeyboardEvent) {
    const modifierKeys = [];

    // 检查Mac系统的cmd键或其他系统的Ctrl键
    if((IS_MAC&&event.metaKey)||event.ctrlKey){
      modifierKeys.push('Mod');
    }

    // 检查Shift键
    if (event.shiftKey) {
      modifierKeys.push('Shift');
    }

    return modifierKeys.join('-');
  }

  destroy(){
    this.dom.removeEventListener('keydown',this.onKeydown);
  }

}
